// Mock data for One Stop Carz website

export const CONTACT = {
  phone: '8460692482',
  phoneDisplay: '+91 84606 92482',
  whatsapp: '918460692482',
  address: 'One Stop Carz, Vadodara, Gujarat',
  tagline: 'મલ્ટીબ્રાન્ડ કાર વર્કશોપ',
};

export const NAV_ITEMS = [
  { label: 'પેકેજ', href: '#packages' },
  { label: 'Diamond AMC', href: '#amc' },
  { label: 'Bodyshop', href: '#bodyshop' },
  { label: 'રિવ્યૂ', href: '#reviews' },
  { label: 'FAQ', href: '#faq' },
];

export const HERO_BULLETS = [
  '48 સર્વિસ ફક્ત ₹4,999 માં — Diamond AMC પ્લાન',
  'ફ્રી પિકઅપ & ડ્રોપ — સમગ્ર વડોદરામાં',
  '100% જેન્યુઇન પાર્ટ્સ અને એક્સપર્ટ ટેકનિશિયન',
  'બહેતર માઈલેજ અને લાંબુ કાર આયુષ્ય',
  'સર્વિસ પર વોરંટી અને પારદર્શક ભાવ',
  'ઓછા ખર્ચે નિયમિત મેન્ટેનન્સ',
];

export const MARQUEE_ITEMS = [
  '100% જેન્યુઇન પાર્ટ્સ',
  'ફ્રી પિકઅપ & ડ્રોપ',
  'એક્સપર્ટ ટેકનિશિયન',
  'સર્વિસ વોરંટી',
  'સમયસર ડિલિવરી',
  'પૈસાની બચત',
  'બેસ્ટ માઈલેજ',
  'ખાતરીપૂર્વક ક્વોલિટી',
];

export const WHY_CHOOSE = [
  { title: '100% જેન્યુઇન પાર્ટ્સ', desc: 'વિશ્વસનીય પરફોર્મન્સ માટે અમે ક્વોલિટી અને જેન્યુઇન પાર્ટ્સ વાપરીએ છીએ.', icon: 'ShieldCheck' },
  { title: 'એક્સપર્ટ & સર્ટિફાઇડ ટેકનિશિયન', desc: 'અનુભવી ટેકનિશિયન પ્રોફેશનલ અને ભરોસાપાત્ર કાર સર્વિસ આપે છે.', icon: 'Wrench' },
  { title: 'સમયસર સર્વિસ', desc: 'અમે સમયસર ડિલિવરી અને કાર્યક્ષમ સર્વિસ પર ધ્યાન આપીએ છીએ.', icon: 'Clock' },
  { title: 'પારદર્શક ભાવ', desc: 'સ્પષ્ટ અને પારદર્શક ભાવ — કોઈ છુપા ચાર્જ નહીં.', icon: 'BadgeIndianRupee' },
  { title: 'સર્વિસ પર વોરંટી', desc: 'ગ્રાહકના વિશ્વાસ માટે સર્વિસ વોરંટી.', icon: 'ShieldCheck' },
  { title: 'ખાતરીપૂર્વક ક્વોલિટી', desc: 'બહેતર પરફોર્મન્સ માટે ક્વોલિટી-ફોકસ્ડ સર્વિસિંગ.', icon: 'Award' },
  { title: 'એડવાન્સ્ડ સર્વિસ કેર', desc: 'યોગ્ય ટૂલ્સ અને પ્રોસિજર સાથે પ્રોફેશનલ મેન્ટેનન્સ.', icon: 'Settings' },
  { title: 'મેન્ટેનન્સ ખર્ચ કંટ્રોલ', desc: 'અમારા પેકેજ અણધાર્યા મેન્ટેનન્સ ખર્ચ ઘટાડવામાં મદદ કરે છે.', icon: 'PiggyBank' },
  { title: 'બહેતર માઈલેજ', desc: 'નિયમિત મેન્ટેનન્સ બહેતર પરફોર્મન્સ અને માઈલેજ જાળવે છે.', icon: 'Gauge' },
  { title: 'ઉંચી રિસેલ વેલ્યુ', desc: 'યોગ્ય મેન્ટેનન્સ કારની કંડિશન અને રિસેલ વેલ્યુ જાળવે છે.', icon: 'TrendingUp' },
];

export const DIAMOND_AMC = {
  id: 'diamond',
  name: 'DIAMOND AMC PLAN',
  subtitle: 'COMPLETE CARE',
  duration: '2 વર્ષ',
  totalServices: '48 સર્વિસ',
  marketPrice: 24400,
  offerPrice: 4999,
  savings: 80,
  perService: 111,
  tag: 'BEST VALUE',
  benefits: [
    'બહેતર કાર પરફોર્મન્સ',
    'મેન્ટેનન્સ પર વધુ બચત',
    'ઉંચી રિસેલ વેલ્યુ',
    'નિયમિત પ્રિવેન્ટિવ મેન્ટેનન્સ',
    'બહેતર માઈલેજ',
    'કારનું લાંબુ આયુષ્ય',
    'પ્રોફેશનલ & સમયસર સર્વિસ',
    'ઝંઝટ-મુક્ત કાર મેન્ટેનન્સ',
  ],
  services: [
    { name: 'PMS – પિરિયોડિક મેન્ટેનન્સ સર્વિસ', times: 4 },
    { name: 'વ્હીલ એલાઈનમેન્ટ', times: 4 },
    { name: 'વ્હીલ બેલેન્સિંગ', times: 4 },
    { name: 'ટાયર રોટેશન', times: 4 },
    { name: 'AC ચેક-અપ', times: 4 },
    { name: 'ઇલેક્ટ્રિકલ ચેક-અપ', times: 4 },
    { name: 'બ્રેક ચેક-અપ', times: 4 },
    { name: 'એર ફિલ્ટર રિપ્લેસમેન્ટ', times: 4 },
    { name: 'ઓઇલ ફિલ્ટર રિપ્લેસમેન્ટ', times: 4 },
    { name: 'બ્રેક ડિસ્ક કટિંગ', times: 2 },
    { name: 'હેડલાઇટ રિસ્ટોરેશન', times: 2 },
  ],
  complimentary: [
    { title: 'ફ્રી પિકઅપ & ડ્રોપ', desc: 'સમગ્ર વડોદરામાં — ઘર/ઓફિસથી ફ્રી' },
    { title: 'ફ્રી જનરલ ચેક-અપ', desc: 'મલ્ટી-પોઈન્ટ ઇન્સ્પેક્શન દરેક સર્વિસ સાથે' },
    { title: 'ફ્રી કાર વોશિંગ', desc: 'એક્સ્ટીરિયર વોશ દરેક વિઝિટ સાથે મફત' },
  ],
  sellingLine: 'Save Big – Get 48 Services for Just ₹5,000!',
};

export const PACKAGES = [
  {
    id: 'basic',
    name: 'BASIC SERVICE PACKAGE',
    subtitle: 'બેઝિક કાર સર્વિસ',
    marketPrice: 6800,
    offerPrice: 3999,
    savings: 41,
    tag: null,
    services: [
      'PMS ચેક-અપ – પિરિયોડિક મેન્ટેનન્સ સર્વિસ',
      'એન્જિન ઓઇલ & ઓઇલ ફિલ્ટર રિપ્લેસમેન્ટ',
      'AC ફિલ્ટર & એર ફિલ્ટર ક્લિનિંગ',
      'કૂલન્ટ ટોપ-અપ',
      'બ્રેક ઓઇલ ટોપ-અપ',
      'વિન્ડશિલ્ડ વોશર ટોપ-અપ',
      'કાર સ્કેનિંગ',
      'ક્લચ ઓપરેશન ચેક',
      'અંડરબોડી ઇન્સ્પેક્શન',
      'સસ્પેન્શન ચેક',
      'બ્રેક ચેક',
      'સ્પાર્ક પ્લગ ચેક',
      'ઇલેક્ટ્રિકલ ચેક-અપ',
      'AC ચેક-અપ',
      'એન્જિન ટ્યુનિંગ',
      'એક્સ્ટીરિયર વોશ',
      'વેક્યુમ ક્લિનિંગ',
      'And Many More Services',
    ],
    applicable: 'પેટ્રોલ & CNG વેરિઅન્ટ કાર (ડીઝલ ભાવ અલગ)',
  },
  {
    id: 'premium',
    name: 'PREMIUM SERVICE PACKAGE',
    subtitle: 'પ્રીમિયમ કાર સર્વિસ',
    marketPrice: 9000,
    offerPrice: 5999,
    savings: 33,
    tag: 'POPULAR',
    services: [
      'PMS ચેક-અપ – પિરિયોડિક મેન્ટેનન્સ સર્વિસ',
      'એન્જિન ઓઇલ & ઓઇલ ફિલ્ટર રિપ્લેસમેન્ટ',
      'AC ફિલ્ટર & એર ફિલ્ટર રિપ્લેસમેન્ટ',
      'કૂલન્ટ રિપ્લેસમેન્ટ',
      'બ્રેક ઓઇલ રિપ્લેસમેન્ટ',
      'વિન્ડશિલ્ડ વોશર રિપ્લેસમેન્ટ',
      'વ્હીલ એલાઈનમેન્ટ',
      'વ્હીલ બેલેન્સિંગ',
      'ટાયર રોટેશન',
      'કાર સ્કેનિંગ',
      'ક્લચ ઓપરેશન ચેક',
      'અંડરબોડી ઇન્સ્પેક્શન',
      'સસ્પેન્શન ચેક',
      'બ્રેક ચેક',
      'સ્પાર્ક પ્લગ ચેક',
      'ઇલેક્ટ્રિકલ ચેક-અપ',
      'AC ચેક-અપ',
      'એન્જિન ટ્યુનિંગ',
      'એક્સ્ટીરિયર વોશ',
      'વેક્યુમ ક્લિનિંગ',
      'And Many More Services',
    ],
    applicable: 'પેટ્રોલ & CNG વેરિઅન્ટ કાર (ડીઝલ ભાવ અલગ)',
  },
];

export const LUXURY_PACKAGE = {
  id: 'luxury',
  name: 'LUXURY CAR CARE',
  subtitle: 'સ્પેશિયલ સર્વિસ પેકેજ',
  suitable: 'લક્ઝરી કાર / પ્રીમિયમ કાર',
  marketPrice: 20000,
  offerPrice: 9999,
  savings: 50,
  tag: 'PREMIUM',
  services: [
    'PMS ચેક-અપ – 72 પોઈન્ટ્સ',
    'એન્જિન ઓઇલ & ઓઇલ ફિલ્ટર રિપ્લેસમેન્ટ',
    'કૂલન્ટ & બ્રેક ઓઇલ ટોપ-અપ',
    'AC ફિલ્ટર & એર ફિલ્ટર ક્લિનિંગ',
    'વિન્ડશિલ્ડ વોશર રિપ્લેસમેન્ટ',
    'વ્હીલ એલાઈનમેન્ટ',
    'વ્હીલ બેલેન્સિંગ',
    'ટાયર રોટેશન',
    'કાર ડાયગ્નોસ્ટિક',
    'ક્લચ ઓપરેશન & અંડરબોડી ઇન્સ્પેક્શન',
    'સસ્પેન્શન & બ્રેક ચેક-અપ',
    'સ્પાર્ક પ્લગ ક્લિનિંગ',
    'ઇલેક્ટ્રિકલ ચેક-અપ',
    'AC ચેક-અપ',
    'એક્સ્ટીરિયર વોશ',
    'વેક્યુમ ક્લિનિંગ',
    'And Many More Services',
  ],
  convenience: [
    'ફ્રી પિકઅપ & ડ્રોપ',
    'ઘરેથી પિકઅપ',
    'ઓફિસથી પિકઅપ',
    'સલામત & સગવડભર્યું',
    'ઝંઝટ-મુક્ત મેન્ટેનન્સ',
  ],
};

// Comparison: ONLY Basic vs Premium with detailed differences
export const COMPARISON = [
  { feature: 'માર્કેટ ભાવ', basic: '₹6,800', premium: '₹9,000' },
  { feature: 'અમારો ભાવ', basic: '₹3,999 + GST', premium: '₹5,999 + GST' },
  { feature: 'બચત', basic: '41%', premium: '33%' },
  { feature: 'PMS ચેક-અપ', basic: '✓', premium: '✓' },
  { feature: 'એન્જિન ઓઇલ & ઓઇલ ફિલ્ટર', basic: 'રિપ્લેસમેન્ટ', premium: 'રિપ્લેસમેન્ટ' },
  { feature: 'AC ફિલ્ટર & એર ફિલ્ટર', basic: 'ક્લિનિંગ', premium: 'રિપ્લેસમેન્ટ' },
  { feature: 'કૂલન્ટ', basic: 'ટોપ-અપ', premium: 'રિપ્લેસમેન્ટ' },
  { feature: 'બ્રેક ઓઇલ', basic: 'ટોપ-અપ', premium: 'રિપ્લેસમેન્ટ' },
  { feature: 'વિન્ડશિલ્ડ વોશર', basic: 'ટોપ-અપ', premium: 'રિપ્લેસમેન્ટ' },
  { feature: 'વ્હીલ એલાઈનમેન્ટ', basic: '✗', premium: '✓' },
  { feature: 'વ્હીલ બેલેન્સિંગ', basic: '✗', premium: '✓' },
  { feature: 'ટાયર રોટેશન', basic: '✗', premium: '✓' },
  { feature: 'કાર સ્કેનિંગ', basic: '✓', premium: '✓' },
  { feature: 'સસ્પેન્શન ચેક', basic: '✓', premium: '✓' },
  { feature: 'બ્રેક ચેક', basic: '✓', premium: '✓' },
  { feature: 'એન્જિન ટ્યુનિંગ', basic: '✓', premium: '✓' },
  { feature: 'એક્સ્ટીરિયર વોશ & વેક્યુમ', basic: '✓', premium: '✓' },
  { feature: 'ફ્રી પિકઅપ & ડ્રોપ', basic: '✓', premium: '✓' },
];

export const TESTIMONIALS = [
  { name: 'રાજેશ પટેલ', car: 'Honda City ઓનર, વડોદરા', text: 'Diamond AMC લીધો — 2 વર્ષ કારની ચિંતા જ નહીં. સર્વિસ ટાઈમ પર અને ફ્રી પિકઅપ-ડ્રોપ એકદમ સગવડભર્યું છે.', initial: 'ર' },
  { name: 'મેહુલ શાહ', car: 'Hyundai Creta ઓનર', text: 'જેન્યુઇન પાર્ટ્સ અને પારદર્શક ભાવ. પહેલા બીજે ડબલ ખર્ચ થતો, હવે One Stop Carz માં બચત થાય છે.', initial: 'મ' },
  { name: 'પ્રિયા દેસાઈ', car: 'Maruti Baleno ઓનર', text: 'મહિલા તરીકે ગેરેજ જવું ટેન્શન હતું, પણ અહીં ઘરેથી પિકઅપ થાય અને ડ્રોપ પણ. ટીમ ખૂબ પ્રોફેશનલ છે.', initial: 'પ' },
  { name: 'અમિત ઠક્કર', car: 'Kia Seltos ઓનર', text: 'Premium પેકેજ કરાવ્યું — માઈલેજ સુધર્યું અને કાર નવી જેવી લાગે છે. ભલામણ કરું છું.', initial: 'અ' },
  { name: 'સંજય મકવાણા', car: 'BMW 3 Series ઓનર', text: 'Luxury Car Care માં 72-પોઈન્ટ ચેકઅપ. ડીલરશીપ કરતાં અડધા ભાવે એ જ ક્વોલિટી સર્વિસ.', initial: 'સ' },
  { name: 'નીતા જોષી', car: 'Tata Nexon ઓનર', text: 'Basic પેકેજ પણ એટલું ડિટેલમાં થાય કે નવાઈ લાગે. વોરંટી પણ મળે એટલે નિશ્ચિંત.', initial: 'ન' },
];

export const FAQS = [
  { q: 'Diamond AMC પ્લાનમાં શું-શું આવે?', a: 'Diamond AMC પ્લાનમાં 2 વર્ષમાં કુલ 48 સર્વિસ સમાવિષ્ટ છે — PMS, વ્હીલ એલાઈનમેન્ટ, બેલેન્સિંગ, ટાયર રોટેશન, AC ચેક-અપ, ઇલેક્ટ્રિકલ ચેક-અપ, બ્રેક ચેક-અપ, એર/ઓઇલ ફિલ્ટર રિપ્લેસમેન્ટ, બ્રેક ડિસ્ક કટિંગ અને હેડલાઇટ રિસ્ટોરેશન. સાથે ફ્રી પિકઅપ & ડ્રોપ પણ.' },
  { q: 'શું ફ્રી પિકઅપ & ડ્રોપ મળે છે?', a: 'હા, સમગ્ર વડોદરામાં તમામ પેકેજ અને AMC સાથે ફ્રી પિકઅપ & ડ્રોપ સેવા મળે છે — ઘરેથી અથવા ઓફિસથી.' },
  { q: 'કઈ કઈ કાર માટે સર્વિસ મળે?', a: 'અમે મલ્ટીબ્રાન્ડ વર્કશોપ છીએ — Maruti, Hyundai, Honda, Tata, Kia, Mahindra, Toyota, Volkswagen, Skoda તથા BMW, Audi, Mercedes જેવી લક્ઝરી કાર પણ સર્વિસ કરીએ છીએ.' },
  { q: 'શું GST અલગથી લાગશે?', a: 'હા, બતાવેલ ઓફર ભાવમાં GST અલગથી લાગુ પડશે.' },
  { q: 'બુકિંગ કઈ રીતે કરવું?', a: '“અત્યારે જ બુક કરો” બટન દબાવીને ફોર્મ ભરો — નામ, મોબાઈલ, કાર મોડલ, બુકિંગ તારીખ અને પેકેજ પસંદ કરો. ₹100 ટોકન થી પણ બુકિંગ શક્ય છે. કન્ફર્મેશન WhatsApp પર મળશે.' },
  { q: 'શું પાર્ટ પેમેન્ટ થાય?', a: 'હા, AMC બુકિંગમાં 25% બુકિંગ એમાઉન્ટ ભરીને પણ બુકિંગ કરી શકાય છે. બાકીની રકમ સર્વિસ સમયે ચૂકવવાની રહેશે.' },
  { q: 'જેન્યુઇન પાર્ટ્સ વપરાય છે?', a: 'હા, અમે 100% જેન્યુઇન અને ક્વોલિટી પાર્ટ્સ જ વાપરીએ છીએ. તમામ સર્વિસ પર વોરંટી પણ મળે છે.' },
  { q: 'ડીઝલ કારના ભાવ કેમ અલગ?', a: 'ડીઝલ કારમાં એન્જિન ઓઇલ ગ્રેડ અને ફિલ્ટર કિંમત વધુ હોવાથી ₹1,500+ પ્લસ થાય છે. ચોક્કસ ભાવ માટે અમારો સંપર્ક કરો.' },
];

export const IMAGES = {
  hero: 'https://images.unsplash.com/photo-1615906655593-ad0386982a0f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxjYXIlMjBlbmdpbmUlMjBzZXJ2aWNlfGVufDB8fHx8MTc4Njc3NTc3Mnww&ixlib=rb-4.1.0&q=85',
  amc: 'https://images.unsplash.com/photo-1645445522156-9ac06bc7a767?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHw0fHxjYXIlMjBtZWNoYW5pY3xlbnwwfHx8fDE3ODY3NzU3NzJ8MA&ixlib=rb-4.1.0&q=85',
  pickup: 'https://images.unsplash.com/photo-1652509573480-a190f1c61f6d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHw0fHxjYXIlMjBrZXlzfGVufDB8fHx8MTc4Njc3NTc3Mnww&ixlib=rb-4.1.0&q=85',
};
